var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.11@lodash/_Symbol.js
// module id = 84
// module chunks = 0